import React, { useRef, useState } from "react";
import { Modal, Toast, Form } from "@douyinfe/semi-ui";
import { renameJobNameApi } from "@services/home/home.api";
import { useTranslation } from "react-i18next";
import type { BaseFormApi as FormApi } from "@douyinfe/semi-foundation/lib/es/form/interface";

interface Prop {
  name: string;
  jid: string;
  submit: (name: string) => void;
  cancel: () => void;
}

interface JobNameModel {
  name: string;
}

const RenameJobnameDialog: React.FC<Prop> = ({ name, jid, submit, cancel }) => {
  const formRef = useRef<FormApi<JobNameModel>>();
  const [loading, setLoading] = useState(false);
  const { t, i18n } = useTranslation();
  async function handleSubmit() {
    try {
      if (!formRef.current) return;
      const values = await formRef.current.validate();
      setLoading(true);
      const { code, message } = await renameJobNameApi(jid, values.name);
      setLoading(false);
      if (code === 200) {
        Toast.success(message);
        submit(values.name);
      }
    } catch (e) {
      // empty
    }
  }

  function confirm() {
    handleSubmit().catch(() => {});
  }

  return (
    <Modal
      zIndex={9999}
      title={t("gadget.renameModal.title")}
      visible={true}
      centered
      onOk={confirm}
      onCancel={cancel}
      okText={t("gadget.renameModal.okText")}
      closeOnEsc={true}
      hasCancel={false}
      confirmLoading={loading}
    >
      <Form
        getFormApi={(formApi) => (formRef.current = formApi)}
        initValues={{ name }}
      >
        {() => (
          <>
            <Form.Input
              field="name"
              label={t("gadget.renameModal.jobName")}
              rules={[{ required: true, message: "This field is required" }]}
              onEnterPress={confirm}
            />
          </>
        )}
      </Form>
    </Modal>
  );
};

export default RenameJobnameDialog;
